import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { SETTINGS } from '../constants';
import { getSideBarStore, SideBarStore } from './layout/sidebar';
import {
  getTestExecutionLayoutStore,
  TestExecutionLayoutStore,
} from './layout/testExecution';

type LayoutStore = SideBarStore & TestExecutionLayoutStore;

export const useLayoutStore = create<
  LayoutStore,
  [['zustand/devtools', never]]
>(
  devtools(
    (...args) => ({
      ...getSideBarStore(...args),
      ...getTestExecutionLayoutStore(...args),
    }),
    { name: 'layoutStore', enabled: SETTINGS.IS_DEV },
  ),
);
